import classnames from 'classnames'
import * as React from 'react'

import { BoxRounding } from '../../../../components/box'
import { getRounding } from '../utils'

interface BoxProps extends React.HTMLProps<HTMLDivElement> {
  'data-testid'?: string
}

export function Box(props: BoxProps) {
  return (
    <div
      className={classnames(props.className, BoxRounding[getRounding()], 'border border-primary')}
      data-testid={props['data-testid']}
    >
      {props.children}
    </div>
  )
}
